import RestService, {ErrorDetails, ResponseStatus, RestCall} from "./restService";
import EnvironmentService from "./environmentService";
import {
    PaymentMethodDto,
    AddPaymentMethodRequestDto,
    UpdatePaymentMethodPriorityRequestDto,
    UpdatePaymentMethodsForPayingRequestDto,
    GetPaymentMethodsResponseDto,
    CompatiblePaymentMethodsResponseDto,
    ReorderPaymentMethodsRequestDto,
} from "../model/functionModels";

async function getPaymentMethods(
    onSuccess: (response: GetPaymentMethodsResponseDto) => Promise<any>,
    onFailure: (a: string) => Promise<any>,
    onRedirection: (newUrl: string) => Promise<any>
) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me/payment-methods`,
            method: "get",
        } as RestCall,
        async (response: ResponseStatus) => {
            await onSuccess(response.body as GetPaymentMethodsResponseDto);
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed getting payment methods!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function addPaymentMethod(
    request: AddPaymentMethodRequestDto,
    onSuccess: () => Promise<any>,
    onFailure: (a: string) => Promise<any>,
    onRedirection: (newUrl: string) => Promise<any>
) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me/payment-methods`,
            method: "post",
            body: request,
        } as RestCall,
        async (_response: ResponseStatus) => {
            await onSuccess();
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed adding payment method!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function updatePaymentMethodPriority(
    request: UpdatePaymentMethodPriorityRequestDto,
    onSuccess: () => Promise<any>,
    onFailure: (a: string) => Promise<any>,
    onRedirection: (newUrl: string) => Promise<any>
) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me/payment-methods/${request.paymentMethodId}/priority`,
            method: "patch",
            body: { priority: request.priority }, // Only send priority, ID is in path
        } as RestCall,
        async (_response: ResponseStatus) => {
            await onSuccess();
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed updating payment method priority!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function updatePaymentMethodsForPaying(
    request: UpdatePaymentMethodsForPayingRequestDto,
    onSuccess: () => Promise<any>,
    onFailure: (a: string) => Promise<any>,
    onRedirection: (newUrl: string) => Promise<any>
) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me/payment-methods/for-paying`,
            method: "patch",
            body: request,
        } as RestCall,
        async (_response: ResponseStatus) => {
            await onSuccess();
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed updating payment methods for paying!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function deletePaymentMethod(
    paymentMethodId: string,
    onSuccess: () => Promise<any>,
    onFailure: (a: string) => Promise<any>,
    onRedirection: (newUrl: string) => Promise<any>
) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me/payment-methods/${paymentMethodId}`,
            method: "delete",
        } as RestCall,
        async (_response: ResponseStatus) => {
            await onSuccess();
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed deleting payment method!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function reorderPaymentMethods(
    request: ReorderPaymentMethodsRequestDto,
    onSuccess: () => Promise<any>,
    onFailure: (a: string) => Promise<any>,
    onRedirection: (newUrl: string) => Promise<any>
) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me/payment-methods/reorder`,
            method: "patch",
            body: request,
        } as RestCall,
        async (_response: ResponseStatus) => {
            await onSuccess();
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed reordering payment methods!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function getCompatiblePaymentMethods(
    targetUserId: string,
    onSuccess: (response: CompatiblePaymentMethodsResponseDto) => Promise<any>,
    onFailure: (a: string) => Promise<any>,
    onRedirection: (newUrl: string) => Promise<any>
) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/${targetUserId}/payment-methods/compatible`,
            method: "get",
        } as RestCall,
        async (response: ResponseStatus) => {
            await onSuccess(response.body as CompatiblePaymentMethodsResponseDto);
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed getting compatible payment methods!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

const PaymentMethodService = {
    getPaymentMethods,
    addPaymentMethod,
    updatePaymentMethodPriority,
    updatePaymentMethodsForPaying,
    deletePaymentMethod,
    getCompatiblePaymentMethods,
    reorderPaymentMethods,
};

export default PaymentMethodService;

